export default __webpack_public_path__ + "static/media/gym-img-07.b804ca32.jpg";